import React, { useContext } from 'react'
import classes from '../../styles/SignupButton.module.css'
import googleLogo from '../../assets/images/google-logo.svg'
import microsoftLogo from '../../assets/images/microsoft-logo.svg'
import emailLogo from '../../assets/images/email-icon.svg'
import { SignupCtx } from '../../pages/SignUp'


const SignupButton = (props: any) => {

  const signupCtx = useContext(SignupCtx)

  let logo: string
  
  switch (props.for) {
    case 'google':
      logo = googleLogo
      break
    case 'microsoft':
      logo = microsoftLogo
      break
    case 'email':
      logo = emailLogo
      break
    default:
      logo = ''
      break
  }

  return (
    <li className={classes.SignupButton}>
      {
        props.link ? 
          <a href={props.link} className={classes.button}>
            <img src={logo} alt={props.for} />
            <span>{props.children}</span>
          </a> :
          <div className={classes.button} onClick={() => signupCtx?.setUser({...signupCtx.user, activeComponent: props.for})}>
            <img src={logo} alt={props.for} />
            <span>{props.children}</span>
          </div>
      }
    </li>
  )
}

export default SignupButton
